const FOUNDERS = '"Founders Grotesk", "Helvetica Neue", Arial, sans-serif';

export const typography = {
  fonts: {
    heading: FOUNDERS,
    body: FOUNDERS,
    mono: "Menlo, monospace",
  },
  fontSizes: {
    display: "clamp(3rem, 8.4vw, 8.5rem)",
    h2: "clamp(2.25rem, 5.4vw, 5rem)",
    h3: "clamp(1.5rem, 2.6vw, 2.6rem)",
    lede: "clamp(1.125rem, 1.6vw, 1.5rem)",
    body: "clamp(1rem, 1.15vw, 1.1875rem)",
    small: "clamp(0.8125rem, 1vw, 0.9375rem)",
    eyebrow: "clamp(0.6875rem, 0.9vw, 0.8125rem)",
    button: "clamp(0.875rem, 1.1vw, 1.125rem)",
    cardTitle: "clamp(1.375rem, 2vw, 2rem)",
    faqQuestion: "clamp(1.0625rem, 1.6vw, 1.5rem)",
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
  },
  lineHeights: {
    display: 0.78,
    section: 0.82,
    card: 0.95,
    tight: 1.1,
    lede: 1.3,
    base: 1.25,
    prose: 1.45,
  },
  letterSpacings: {
    display: "-0.015em",
    section: "-0.005em",
    eyebrow: "0.14em",
    button: "0.003em",
  },
};
